import { SingleValue } from 'react-select';

import { DataWidgetFiltersInput } from 'dashboards/types/filter';
import { Select } from 'components/Select/Select';

import { useDataWidgetFiltersInputState } from './context';

//  Columns for which we provide dropdown suggestions.
const COLUMNS_WITH_SUGGESTIONS = [
  'deployment_id',
  'gateway_id',
  'pipeline_id',
  'source_id',
];

// Users should select *_id columns instead.
const HIDDEN_COLUMNS = [
  'deployment_name',
  'gateway_name',
  'pipeline_name',
  'source_name',
];

type ColumnOption = {
  value: string;
  label: string;
};

type ColumInputProps = Pick<DataWidgetFiltersInput, 'id' | 'column'>;

export function ColumnInput({ id, column }: ColumInputProps) {
  const { columns, updateFilter } = useDataWidgetFiltersInputState();

  const columnOptions = columns
    .filter(({ name }) => !HIDDEN_COLUMNS.includes(name))
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(({ name }) => ({ label: name, value: name }));

  function handleColumnChange(selectedColumn: SingleValue<ColumnOption>) {
    if (!selectedColumn?.value) {
      return;
    }

    // Clear value when switching to and from a dropdown input
    if (
      COLUMNS_WITH_SUGGESTIONS.includes(selectedColumn.value) ||
      (COLUMNS_WITH_SUGGESTIONS.includes(column) &&
        !COLUMNS_WITH_SUGGESTIONS.includes(selectedColumn.value))
    ) {
      updateFilter(id, { column: selectedColumn.value, value: '' });
      return;
    }

    updateFilter(id, { column: selectedColumn.value });
  }

  return (
    <Select
      placeholder="Select column..."
      defaultValue={{ value: column, label: column }}
      options={columnOptions}
      onChange={handleColumnChange}
    />
  );
}
